var render = function render(){var _vm=this,_c=_vm._self._c;return _c('H5Layout',{attrs:{"title":"语音识别录音","active":"meeting"}},[_c('AMeeting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }